
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/blogs",
      function () {
        return require("private-next-pages/users/[id]/blogs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/blogs"])
      });
    }
  